import { TableEmptyState } from '@practium/ui';
import type { TestimonialDTO } from '@practium/features/api';
import styles from '../LandingTable.module.css';

interface TestimonialsTableProps {
	testimonials: TestimonialDTO[];
	onRowClick?: (id: string) => void;
}

export const TestimonialsTable = ({ testimonials, onRowClick }: TestimonialsTableProps) => {
	if (testimonials.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum depoimento encontrado"
				subtitle="Adicione um depoimento para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Tipo</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{testimonials.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.occupation || '-'}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${
										item.status ? styles.statusActive : styles.statusInactive
									}`}
								>
									{item.status ? 'Ativo' : 'Inativo'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
